import GuessingMap from './GuessingMap';

export default GuessingMap;
